import { useEffect, useState } from "react";
function getMediaQueryList(query) {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return null;
    }
    try {
        return window.matchMedia(query);
    }
    catch {
        return null;
    }
}
export function mediaQueryMatches(query) {
    return getMediaQueryList(query)?.matches ?? false;
}
export function subscribeToMediaQuery(query, onChange) {
    const mediaQuery = getMediaQueryList(query);
    if (!mediaQuery)
        return () => { };
    const listener = (event) => onChange(event.matches);
    if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", listener);
        return () => mediaQuery.removeEventListener?.("change", listener);
    }
    // Safari/WebKit before MediaQueryList inherited EventTarget.
    if (typeof mediaQuery.addListener === "function") {
        mediaQuery.addListener(listener);
        return () => mediaQuery.removeListener?.(listener);
    }
    return () => { };
}
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => mediaQueryMatches(query));
    useEffect(() => {
        setMatches(mediaQueryMatches(query));
        return subscribeToMediaQuery(query, setMatches);
    }, [query]);
    return matches;
}
